"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusLabel = StatusLabel;

var _typography = require("./typography");

var _styles = require("react-components/styles");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Color themes.
 */
var colorThemes = {
  danger: {
    border: (0, _styles.color)('danger400'),
    label: (0, _styles.color)('danger')
  },
  "default": {
    border: (0, _styles.color)('gray400'),
    label: (0, _styles.color)('gray')
  },
  info: {
    border: (0, _styles.color)('blue400'),
    label: (0, _styles.color)('primary')
  },
  success: {
    border: (0, _styles.color)('success300'),
    label: (0, _styles.color)('success')
  },
  warning: {
    border: (0, _styles.color)('warning400'),
    label: (0, _styles.color)('warning')
  }
};
/**
 * Export `StatusLabelColorTheme` type.
 */

/**
 * `StatusWrapper` styled component.
 */
var StatusWrapper = _styledComponents["default"].div.withConfig({
  displayName: "status-label__StatusWrapper",
  componentId: "sc-c4yehr-0"
})(["align-items:center;border:1px solid ", ";border-radius:8px;display:flex;padding:1px 5px;", ""], function (_ref) {
  var colorTheme = _ref.colorTheme;
  return colorThemes[colorTheme].border;
}, _styles.media.min('sm')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 3px 5px;\n  "]))));
/**
 * `Label` styled component.
 */


var Label = (0, _styledComponents["default"])(_typography.Text).attrs({
  size: 'small'
}).withConfig({
  displayName: "status-label__Label",
  componentId: "sc-c4yehr-1"
})(["color:", ";"], function (_ref2) {
  var colorTheme = _ref2.colorTheme;
  return colorThemes[colorTheme].label;
});
/**
 * Export `StatusLabel` component.
 */

function StatusLabel(_ref3) {
  var className = _ref3.className,
      colorTheme = _ref3.colorTheme,
      label = _ref3.label;
  return /*#__PURE__*/_react["default"].createElement(StatusWrapper, {
    className: className,
    colorTheme: colorTheme
  }, /*#__PURE__*/_react["default"].createElement(Label, {
    colorTheme: colorTheme
  }, label));
}